import PropTypes from "prop-types";
import React from "react";
import { Button } from "cxa-components";
import EthnicitySelect from "./ethnicitySelect";
import { getPixelCrop } from "./utils";
import ReactCrop from "react-image-crop";
import { injectIntl } from "react-intl";
import messages from "components/messagesDescription";

class CropImageForm extends React.Component {
  constructor() {
    super();

    this.state = {
      crop: null,
      pixelCrop: null,
      naturalImage: null,
    };

    this.handleConfirmUpload = this.handleConfirmUpload.bind(this);
    this.handleImageLoaded = this.handleImageLoaded.bind(this);
    this.setCropCoordinates = this.setCropCoordinates.bind(this);
  }

  setCropCoordinates = crop => {
    this.setState({
      crop,
      pixelCrop: getPixelCrop(this.state.naturalImage, crop),
    });
  };

  handleImageCropOnChange = crop => {
    this.setCropCoordinates(crop);
  };

  handleCropComplete = crop => {
    this.setCropCoordinates(crop);
  };

  handleImageLoaded = image => {
    const cropDefaultValues = { x: 2, y: 2, height: 96, width: 96 };

    this.setState({
      crop: cropDefaultValues,
      pixelCrop: getPixelCrop(image, cropDefaultValues),
      naturalImage: image,
    });
  };

  handleConfirmUpload(event) {
    const { pixelCrop } = this.state;

    if (event) {
      event.preventDefault();
    }

    // call API
    if (pixelCrop) {
      const { filename } = this.props.uploadImageResponse;

      // IE Fix - Recompute the pixelCrop values to make sure we are passing the right coordinates
      const recomputePixelCrop = getPixelCrop(this.props.uploadImageResponse, this.state.crop);
      const ageParams = { ...recomputePixelCrop, filename };

      this.props.setAgeFaceParams(ageParams);
      this.props.confirmUploadPhoto(this.props.ethnicity);
    }
  }

  render() {
    const uploadedImage = this.props.uploadImageResponse;
    const intl = this.props.intl;
    const { crop } = this.state;
    return (
      <article className="card">
        <section>
          {uploadedImage && (
            <ReactCrop
              src={uploadedImage.image}
              keepSelection={true}
              crop={crop}
              onImageLoaded={this.handleImageLoaded}
              onChange={this.handleImageCropOnChange}
              onComplete={(crop, pixelCrop) => this.handleCropComplete(crop, pixelCrop)}
            />
          )}
          <EthnicitySelect
            ethnicity={this.props.ethnicity}
            handleChangeEthnicity={this.props.handleChangeEthnicity}
          />
        </section>
        <footer>
          <p id="buttons">
            <Button secondary onClick={this.props.handleReUpload}>
              {intl.formatMessage(messages.reUploadDescription)}
            </Button>{" "}
            <Button primary submitting={this.props.submitting} onClick={this.handleConfirmUpload}>
              {intl.formatMessage(messages.nextTextDescription)}
            </Button>
          </p>
        </footer>
      </article>
    );
  }
}

CropImageForm.propTypes = {
  uploadImageResponse: PropTypes.object,
  setAgeFaceParams: PropTypes.func,
  confirmUploadPhoto: PropTypes.func,
  handleChangeEthnicity: PropTypes.func,
  handleReUpload: PropTypes.func,
  ethnicity: PropTypes.node,
  submitting: PropTypes.bool,
  intl: PropTypes.object,
};

export default injectIntl(CropImageForm);



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/cropImageForm.jsx